import { observer } from 'mobx-react-lite';

import { CustomServerCards } from 'cfx/apps/mpMenu/parts/CustomServerCards/CustomServerCards';
import { LegacyConnectingModal } from 'cfx/apps/mpMenu/parts/LegacyConnectingModal/LegacyConnectingModal';
import { ThemeManager } from 'cfx/apps/mpMenu/parts/ThemeManager/ThemeManager';

import { AcitivityItemMediaViewerProvider } from '../AcitivityItemMediaViewer/AcitivityItemMediaViewer.context';

export const MpMenuApp = observer(function MpMenuApp() {
  // UI stripped — themed background (ThemeManager) + custom server cards.
  // LegacyConnectingModal kept so the connect flow shows progress/failure UI.
  return (
    <AcitivityItemMediaViewerProvider>
      <ThemeManager />

      <LegacyConnectingModal />

      <CustomServerCards />
    </AcitivityItemMediaViewerProvider>
  );
});
